import React, {useEffect, useState, useCallback} from 'react';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import OccasionalCreditCardInputMain from './OccasionalCreditCardInputMain';
import {ProgramSteps} from './OccasionalCreditCardInputEnumsAndVariables';
import SuccessOrErrorScreen from '../FamilyMemberCellularSaleBlock/OrganizationFamilyMembersSale/successOrErrorScreen/SuccessOrErrorScreen';
import hey from './images/hey.svg';
import thumbUp from './images/thumb_up.svg';
import {cleanSliceData} from './OccasionalCreditCardInputSlice';
import {setTryAgainRequest, setEmvStep2StatusToFailure} from '../SaleBlock/PaymentCG/PaymentCGSlice';

const OccasionalCreditCardInputStepsManager = ({
  iContent,
  currentStep,
  cleanSliceData,
  setTryAgainRequest,
  setEmvStep2StatusToFailure,
  opportunityId,
}) => {
  const [currentJsxCmpToRender, setCurrentJsxCmpToRender] = useState(null);

  const goToMainPage = useCallback(() => {
    EpiContext.navigateTo();
  }, []);

  useEffect(() => {
    if(checkMlClosedStatusInSessionStorage()){
      setCurrentJsxToSuccessPage();
    }
    else{
      switch (currentStep) {
        case ProgramSteps.ERROR_WITH_TOKEN: {
          setCurrentJsxCmpToRender(
            <SuccessOrErrorScreen
              popUpObj={{
                icon: hey,
                heading: 'מצטערים, משהו השתבש בתהליך זיהוי הלקוח ולכן לא ניתן להמשיך בתהליך',
                secondaryHeading: 'נציגנו ישמחו לסייע לך',
                whiteBlackBtn: {
                  text: 'לפרטים ומידע נוסף התקשרו ל-2759*',
                },
                buttonText: 'חזרה לדף ראשי',
                btnClickedCallBack: goToMainPage,
              }}
            />,
          );
          break;
        }
        case ProgramSteps.OPPORTUNITY_ID_NOT_FOUND: {
          setCurrentJsxCmpToRender(
            <SuccessOrErrorScreen
              popUpObj={{
                icon: hey,
                heading: 'מצטערים, משהו השתבש בתהליך ולא ניתן לבצע את הפעולה שביקשת',
                secondaryHeading: 'נציגנו ישמחו לסייע לך',
                whiteBlackBtn: {
                  text: 'לפרטים ומידע נוסף התקשרו ל-2759*',
                },
                buttonText: 'חזרה לדף ראשי',
                btnClickedCallBack: goToMainPage,
              }}
            />,
          );
          break;
        }
        case ProgramSteps.BLACK_LIST_VALIDATION_GENERAL_ERROR: {
          setEmvStep2StatusToFailure();
          setTryAgainRequest(true);
          setCurrentJsxCmpToRender(
            <SuccessOrErrorScreen
              popUpObj={{
                icon: hey,
                heading: 'מצטערים, משהו השתבש בתהליך עקב תקלה טכנית',
                secondaryHeading: 'נציגנו ישמחו לסייע לך',
                whiteBlackBtn: {
                  text: 'לפרטים ומידע נוסף התקשרו ל-2759*',
                },
                buttonText: 'נסה שוב',
                btnClickedCallBack: () => {
                  cleanSliceData();
                },
                whiteBlackBigBtnText: 'חזרה לדף ראשי',
                whiteBlackBigBtnClickedCallBack: goToMainPage,
              }}
            />,
          );
          break;
        }
        case ProgramSteps.JET_UPDATE_GENERAL_ERROR: {
          setCurrentJsxCmpToRender(
            <SuccessOrErrorScreen
              popUpObj={{
                icon: hey,
                heading: 'אנו מצטערים, אך התהליך לא הושלם בהצלחה.',
                secondaryHeading: 'נציגנו ישמחו לסייע לך',
                whiteBlackBtn: {
                  text: 'לפרטים ומידע נוסף התקשרו ל-2759*',
                },
                buttonText: 'חזרה לדף ראשי',
                btnClickedCallBack: goToMainPage,
              }}
            />,
          );
          break;
        }
        case ProgramSteps.SUCCESS_PAGE: {
          setCurrentJsxToSuccessPage();
          break;
        }
        default: {
          setCurrentJsxCmpToRender(<OccasionalCreditCardInputMain iContent={iContent} />);
          break;
        }
      }
    }
  }, [currentStep]);

  function checkMlClosedStatusInSessionStorage() {
    try {
      const jsonStringObj = sessionStorage.getItem('creditCardInfoMlObj');
      const jsonObj = JSON.parse(jsonStringObj);
      if (jsonObj?.isMagicLinkClosed) {
        if(jsonObj?.mlOpportunityId === opportunityId){
          return true;
        }
        sessionStorage.removeItem('creditCardInfoMlObj');
      }
      return false;
    } catch {
      return false;
    }
  }

  function setCurrentJsxToSuccessPage(){
    setCurrentJsxCmpToRender(
      <SuccessOrErrorScreen
        popUpObj={{
          icon: thumbUp,
          heading: 'הכרטיס נקלט בהצלחה',
          secondaryHeading: 'תודה שבחרת להשתמש בשירותינו',
          whiteBlackBtn: {
            text: 'לפרטים ומידע נוסף התקשרו ל-2759*',
          },
          buttonText: 'חזרה לדף ראשי',
          btnClickedCallBack: goToMainPage,
        }}
      />,
    );
  }

  return currentJsxCmpToRender;
};



const mapStateToProps = (state) => ({
  currentStep: state.OccasionalCreditCardInput?.currentProgramStep,
  opportunityId: state.authentication?.loginData?.magicLinkParameters?.opportunityId,
});

const mapDispatchToProps = {cleanSliceData, setTryAgainRequest, setEmvStep2StatusToFailure};

export default connect(mapStateToProps, mapDispatchToProps)(OccasionalCreditCardInputStepsManager);
